import React from "react";

import "./style.css"

export default function({style, children}){
    return (
        <div className="floating-card-container" style={style}>{children}</div>
    )
}